'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './link-list-edit.routes';

export class LinkListEditComponent {

  constructor(Auth, dialogs, SettingsService, $uibModal, $state, $stateParams, $location, Config, StorageService) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;
    this.SettingsService = SettingsService;

    this.setting = {};

    this.linkListName = $stateParams.name;

    SettingsService.getByName({name: this.linkListName}, setting => {
      this.setting = setting;
    }, err => {
    });

    this.sortableOptions = {
        handle: '.handle'
    };
  }

  add() {
    this.setting.data.linkList.push({
      "url": "",
      "title": "",
      "beforeText": "",
      "afterText": "",
      "openNewTab": true
    });
  }

  delete($event, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Link?", "Do you really want to delete the link?");
    dlg.result.then(() => {
      this.setting.data.linkList.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {
    var onSuccess = (data) => {
      this.dialogs.notify("Success", "Changes have been saved successfully");
    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    this.SettingsService.update({id: this.setting._id}, this.setting, onSuccess, onError);
  }

}

export default angular.module('conduuApp.linkListEdit', [uiRouter])
  .config(routes)
  .component('linkListEdit', {
    template: require('./link-list-edit.html'),
    controller: LinkListEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/link-list-edit/link-list-edit.component.js